import React from 'react';
import styled from 'styled-components';
import { GridContainer } from '../GridContainer';
const Grid = styled(GridContainer) `
  align-items: self-start;
  grid-gap: var(--layout-soybean) var(--layout-shoe);
  grid-template-columns: 1fr;
  grid-template-rows: min-content;
`;
/**
 * @deprecated - Please use the LayoutGridItem Component from UI Toolkit within a LayoutGrid
 * {@link https://frontend-ds.cko-dev.ckotech.co/?path=/docs/layoutgrid--docs}
 */
export const GridRow = ({ children }) => (React.createElement(Grid, null,
    React.createElement(Grid, null, children)));
